export enum WAREHOUSE_PERMISSIONS {
  WAREHOUSE_VIEW = 'INVENTORY_WAREHOUSEVIEW',
  WAREHOUSE_WRITE = 'INVENTORY_WAREHOUSEWRITE',
  WAREHOUSE_SUPPLIER_PROVIDER_VIEW = 'PROVIDER_WAREHOUSESUPPLIERVIEW',
  WAREHOUSE_SUPPLIER_PROVIDER_WRITE = 'PROVIDER_WAREHOUSESUPPLIERWRITE',
}
